import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useRoutes,
  Navigate
} from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { http, WagmiProvider, createConfig, configureChains } from 'wagmi';
import { Provider } from "react-redux";
import store from "./store";
import { bsc, bscTestnet } from "wagmi/chains";
import { injected, walletConnect, metaMask } from 'wagmi/connectors'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import "@fortawesome/fontawesome-free/css/all.min.css";
import Home from "./pages/home.js";
import Buytoken_page from "./pages/buytoken.js";

const config = createConfig({
  autoConnect: true,
  chains: [bsc, bscTestnet],
  transports: {
    [bsc.id]: http(),
    [bscTestnet.id]: http(),
  },
  connectors: [
    metaMask({
      autoConnect: true,
      chains: [bsc, bscTestnet],
      target: 'metaMask',
    }),

    walletConnect({
      autoConnect: true,
      projectId: 'cb89ebb21cdccb2e1b591e189e27706a',
      showQrModal: true,
    }),
  ],
})

const queryClient = new QueryClient()

const App = () => {
  const routes = useRoutes([
    { path: "/*", element: <Navigate to="/" /> },
    { path: "/", element: <Home /> },
    { path: "/dashboard", element: <Buytoken_page /> },
  ]);
  return routes;
};

const AppWrapper = () => {
  return (
    <Router basename="/">
      <Provider store={store}>
        <WagmiProvider config={config}>
          <QueryClientProvider client={queryClient}>
            <SnackbarProvider />
            <App />
          </QueryClientProvider>
        </WagmiProvider>
      </Provider>
    </Router>
  );
};

export default AppWrapper;
